import React from 'react';
import { BotIcon } from 'lucide-react';
import { ChevronDownIcon } from 'lucide-react';
import { FC } from 'react';
import { forwardRef } from 'react';
import { AssistantModalPrimitive } from '@assistant-ui/react';
import { Thread } from 'apps/sigma2-ui/src/components/assistant-ui/thread';
import { TooltipIconButton } from 'apps/sigma2-ui/src/components/assistant-ui/tooltip-icon-button';
import { useUserObservationOrgAndDbIds } from 'apps/sigma2-ui/src/lib/hooks/useUserObservationOrgAndDbIds';

export const AssistantModal: FC = () => {
  const {
    selectedOrganizationId,
    selectedDatabaseId,
    selectedDatabaseRevisionId,
  } = useUserObservationOrgAndDbIds();

  if (
    !selectedOrganizationId ||
    !selectedDatabaseId ||
    !selectedDatabaseRevisionId
  ) {
    return;
  }

  return (
    <AssistantModalPrimitive.Root>
      <AssistantModalPrimitive.Anchor className="fixed right-4 bottom-4 z-50 size-11">
        <AssistantModalPrimitive.Trigger asChild>
          <AssistantModalButton />
        </AssistantModalPrimitive.Trigger>
      </AssistantModalPrimitive.Anchor>

      <AssistantModalPrimitive.Content
        sideOffset={16}
        className="fixed right-4 bottom-16 z-50 w-[400px] h-[500px] overflow-hidden rounded-xl border bg-white shadow-xl outline-none"
      >
        <Thread />
      </AssistantModalPrimitive.Content>
    </AssistantModalPrimitive.Root>
  );
};

type AssistantModalButtonProps = { 'data-state'?: 'open' | 'closed' };

const AssistantModalButton = forwardRef<
  HTMLButtonElement,
  AssistantModalButtonProps
>(({ 'data-state': state, ...rest }, ref) => {
  const tooltip = state === 'open' ? 'Close Assistant' : 'Open Assistant';

  return (
    <TooltipIconButton
      tooltip={tooltip}
      side="left"
      {...rest}
      className="aui-modal-button size-full rounded-full shadow transition-transform hover:scale-110 active:scale-90"
      ref={ref}
    >
      <BotIcon
        data-state={state}
        className="aui-modal-button-closed-icon absolute size-6 transition-all data-[state=closed]:rotate-0 data-[state=open]:rotate-90 data-[state=closed]:scale-100 data-[state=open]:scale-0"
      />

      <ChevronDownIcon
        data-state={state}
        className="aui-modal-button-open-icon absolute size-6 transition-all data-[state=closed]:-rotate-90 data-[state=open]:rotate-0 data-[state=closed]:scale-0 data-[state=open]:scale-100"
      />
      <span className="aui-sr-only sr-only">{tooltip}</span>
    </TooltipIconButton>
  );
});

AssistantModalButton.displayName = 'AssistantModalButton';
